import angular from 'angular';
import 'flickity/dist/flickity.min.css';
const Flickity = require('flickity/js');

require('flickity-imagesloaded');
require('flickity-fullscreen');

(function() {
    'use strict';

    angular.module('app').component('pricing2', {
        template: require('./pricing.html'),
        controller: Controller,
        controllerAs: 'vm'
    });

    Controller.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        'QueryService',
        'SessionService',
        'LanguageService',
        'logger'
    ];

    function Controller(
        $scope,
        $state,
        $stateParams,
        QueryService,
        SessionService,
        LanguageService,
        logger
    ) {
        var vm = this;
        vm.strings = LanguageService.strings;

        vm.carousel = 1;
        vm.packages = [
            { name: 'Basic111', price: '-30,000', days: '5', minutes: '15' },
            { name: 'Basic111', price: '-30,000', days: '5', minutes: '15' },
            { name: 'Basic', price: '30,000', days: '5', minutes: '15' },
            { name: 'Standard', price: '30,000', days: '5', minutes: '30' },
            { name: 'Premium', price: '60,000', days: '5', minutes: '60' }
        ];

        vm.packages.forEach((v, i) => {
            v.index = i;
        });

        vm.flkty = new Flickity('.slider', {
            cellSelector: '.package',
            initialIndex: 0,
            draggable: true,
            // freeScroll: true,
            prevNextButtons: true,
            wrapAround: true
        });

        vm.log = () => {
            console.log(vm.flkty);
        };

        vm.seeAll = () => {
            window.location.replace('https://jjdayoungenglish.wixsite.com/website/pricing');
        }

        vm.pricing_loc = 'https://jjdayoungenglish.wixsite.com/website/pricing';

        vm.flkty.on('change', () => {
            console.log('change');
        });

        vm.flkty.on('scroll', change);

        change(null, 0);
        function change(e, progress) {
            console.log('change', progress);
            vm.flkty.cells.forEach(c => {
                if (c.element.classList.contains('center_package')) {
                    c.element.classList.remove('center_package');
                    c.element.classList.add('scale_down');
                }
            });

            const i = parseInt(5 + (progress - 700 / 6) / (700 / 3)) % 4;

            vm.flkty.cells[i].element.classList.add('center_package');
            vm.flkty.cells[i].element.classList.remove('scale_down');
        }

    }
})();



// WEBPACK FOOTER //
// ./src/app/components/pricing2/pricing.component.js